import { gql } from '@apollo/client';

export const ACTIVE_PLAN_COVERAGE = gql`
  query getActiveCoverages(
    $sourceUrl: String
    $count: String
    $offset: Int
  ) {
    getActiveCoverages(
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
    ) {
      coverageList
    }
  }
`;
